'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BIRTH_LAYOUT = exports.NUM_LAYOUT = exports.NAME_LAYOUT = exports.HR_LAYOUT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  user-select:none;\n  tap-highlight-color: rgba(0,0,0,0);\n  transition: transform 0.15s ease-out, opacity 0.15s ease-in-out;\n  display: block;\n  cursor: pointer;\n  flex: 70px 0;\n  padding: 10px 5px;\n  color: #444;\n\n  &.pressed {\n    transform: scale(0.9);\n  }\n\n  opacity: 0.6;\n\n  &.enabled {\n    opacity: 1;\n  }\n\n  & > div {\n    background: ', ';\n    color: ', ';\n    display: block;\n    text-align: center;\n    line-height: 60px;\n    vertical-align: middle;\n    border-radius: 10px;\n    padding: 15px 0;\n    font-family: \'Roboto\';\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  &.space.pressed {\n    transform: scale(0.95);\n  }\n\n  &.space {\n    flex: 453px 0;\n  }\n\n  &.backspace > div, &.enter > div {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n'], ['\n  user-select:none;\n  tap-highlight-color: rgba(0,0,0,0);\n  transition: transform 0.15s ease-out, opacity 0.15s ease-in-out;\n  display: block;\n  cursor: pointer;\n  flex: 70px 0;\n  padding: 10px 5px;\n  color: #444;\n\n  &.pressed {\n    transform: scale(0.9);\n  }\n\n  opacity: 0.6;\n\n  &.enabled {\n    opacity: 1;\n  }\n\n  & > div {\n    background: ', ';\n    color: ', ';\n    display: block;\n    text-align: center;\n    line-height: 60px;\n    vertical-align: middle;\n    border-radius: 10px;\n    padding: 15px 0;\n    font-family: \'Roboto\';\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  &.space.pressed {\n    transform: scale(0.95);\n  }\n\n  &.space {\n    flex: 453px 0;\n  }\n\n  &.backspace > div, &.enter > div {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  font-size: 50px;\n\n  &.letters3name {\n    left: 0;\n  }\n\n  &.emailSpecial .Key {\n    font-size: 50px;\n  }\n\n  &.emailSpecial .Key.small {\n    font-size: 30px;\n  }\n\n  &.emailSpecial .Key.small > div {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  &.numbers .Key > div {\n    min-width: 120px;\n    height: 120px;\n    line-height: 120px;\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  font-size: 50px;\n\n  &.letters3name {\n    left: 0;\n  }\n\n  &.emailSpecial .Key {\n    font-size: 50px;\n  }\n\n  &.emailSpecial .Key.small {\n    font-size: 30px;\n  }\n\n  &.emailSpecial .Key.small > div {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  &.numbers .Key > div {\n    min-width: 120px;\n    height: 120px;\n    line-height: 120px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n'], ['\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _doohReactUtils = require('dooh-react-utils');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var KeyWrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.keyboardBackgroundColor || '#FE0000';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.keyboardTextColor || 'white';
});

var Key = function (_React$Component) {
  _inherits(Key, _React$Component);

  function Key(props) {
    _classCallCheck(this, Key);

    var _this = _possibleConstructorReturn(this, (Key.__proto__ || Object.getPrototypeOf(Key)).call(this, props));

    _this.handlePress = function () {
      if (!_this.props.enabled) return;
      if (_this.props.onKey) _this.props.onKey(_this.props.value);
      _this.setState({ pressed: true });
      setTimeout(function () {
        return _this.setState({ pressed: false });
      }, 150);
    };

    _this.state = { pressed: false };
    return _this;
  }

  _createClass(Key, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          label = _props.label,
          enabled = _props.enabled;

      var cls = (0, _classnames2.default)('Key', className, { pressed: this.state.pressed, enabled: enabled });
      return _react2.default.createElement(
        KeyWrapper,
        { className: cls },
        _react2.default.createElement(
          _doohReactUtils.Tap,
          { onTap: this.handlePress, preventDoubleTap: false },
          label
        )
      );
    }
  }]);

  return Key;
}(_react2.default.Component);

var RowWrapper = _styledComponents2.default.div(_templateObject2);

var Row = function Row(props) {
  return _react2.default.createElement(
    RowWrapper,
    { className: (0, _classnames2.default)('Row', props.row.groupName, props.row.className) },
    props.row.keys.map(function (k, i) {
      return _react2.default.createElement(Key, {
        key: i,
        label: k.label,
        className: k.className,
        value: k.value,
        enabled: props.isKeyEnabled(k.value),
        onKey: props.onKey });
    })
  );
};

var KeyboardWrapper = _styledComponents2.default.div(_templateObject3);

var Keyboard = function (_React$Component2) {
  _inherits(Keyboard, _React$Component2);

  function Keyboard() {
    var _ref3;

    var _temp, _this2, _ret;

    _classCallCheck(this, Keyboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref3 = Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call.apply(_ref3, [this].concat(args))), _this2), _this2.handleKeyDown = function (e) {
      if (e.code === 'Backspace' || e.key === 'Backspace') {
        _this2.props.onKey('backspace');
      }
    }, _this2.handleKeyPress = function (e) {
      if (e.charCode === 13) {
        // enter
        if (_this2.props.isKeyEnabled('enter')) _this2.props.onKey('enter');
      } else if (e.charCode === 32) {
        // space
        if (_this2.props.isKeyEnabled('space')) _this2.props.onKey('space');
      } else {
        var ch = String.fromCharCode(e.charCode);
        if (_this2.props.isKeyEnabled(ch)) _this2.props.onKey(ch);
      }
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(Keyboard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('keypress', this.handleKeyPress);
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keypress', this.handleKeyPress);
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          layout = _props2.layout,
          onKey = _props2.onKey,
          className = _props2.className,
          isKeyEnabled = _props2.isKeyEnabled;


      return _react2.default.createElement(
        KeyboardWrapper,
        { className: (0, _classnames2.default)('Keyboard', className) },
        layout.map(function (row) {
          return _react2.default.createElement(Row, _extends({ key: row.groupName }, { row: row, onKey: onKey, isKeyEnabled: isKeyEnabled }));
        })
      );
    }
  }]);

  return Keyboard;
}(_react2.default.Component);

Keyboard.defaultProps = {
  isKeyEnabled: function isKeyEnabled(value) {
    return true;
  }
};
var HR_LAYOUT = exports.HR_LAYOUT = [{
  groupName: 'numbers1',
  keys: "1234567890".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'letters1',
  keys: "qwertzuiopšđ".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'letters2',
  keys: "asdfghjklčćž".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'letters3',
  keys: "yxcvbnm.,-".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'space',
  keys: [{ label: 'Briši', value: 'backspace', className: 'backspace' }, { label: '\xA0', value: 'space', className: 'space' }, { label: 'Dalje', value: 'enter', className: 'enter' }]
}];

var NAME_LAYOUT = exports.NAME_LAYOUT = [{
  groupName: 'letters1',
  keys: "qwertzuiopšđ".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'letters2',
  keys: "asdfghjklčćž".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'letters3name',
  keys: "yxcvbnm".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'space',
  keys: [{ label: 'Briši', value: 'backspace', className: 'backspace' }, { label: '\xA0', value: 'space', className: 'space' }, { label: 'Dalje', value: 'enter', className: 'enter' }]
}];

var NUM_LAYOUT = exports.NUM_LAYOUT = [{
  groupName: 'numbers1',
  className: 'numbers',
  keys: "123".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'numbers2',
  className: 'numbers',
  keys: "456".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'numbers3',
  className: 'numbers',
  keys: "789".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'space',
  className: 'numbers',
  keys: [{ label: 'Briši', value: 'backspace', className: 'backspace' }, { label: '0', value: '0' }, { label: 'Dalje', value: 'enter', className: 'enter' }]
}];

var BIRTH_LAYOUT = exports.BIRTH_LAYOUT = [{
  groupName: 'numbers1',
  className: 'numbers',
  keys: "123".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'numbers2',
  className: 'numbers',
  keys: "456".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'numbers3',
  className: 'numbers',
  keys: "789".split('').map(function (k) {
    return { label: k, value: k };
  })
}, {
  groupName: 'space',
  className: 'numbers',
  keys: [{ label: 'Briši', value: 'backspace', className: 'backspace' }, { label: '0', value: '0' }, { label: '.', value: '.' }, { label: 'Dalje', value: 'enter', className: 'enter' }]
}];

exports.default = Keyboard;


//////////////////
// WEBPACK FOOTER
// ./~/dooh-react-utils/dist/form/Keyboard.js
// module id = 139
// module chunks = 0